/**
 * @generated SignedSource<<241ffb0cfd9ecff6b163beb2aff75cb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdatePaymentTermsInput = {
  paymentMethodIdentifier: string;
  paymentTerms: string;
};
export type UpdatePaymentTermsDialogMutation$variables = {
  input: UpdatePaymentTermsInput;
};
export type UpdatePaymentTermsDialogMutation$data = {
  readonly updatePaymentTerms: {
    readonly id: string;
    readonly paymentTerms: string | null | undefined;
  };
};
export type UpdatePaymentTermsDialogMutation = {
  response: UpdatePaymentTermsDialogMutation$data;
  variables: UpdatePaymentTermsDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PaymentMethod",
    "kind": "LinkedField",
    "name": "updatePaymentTerms",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paymentTerms",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatePaymentTermsDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdatePaymentTermsDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f155e0e8f2bed3354e28c450570df4d6",
    "id": null,
    "metadata": {},
    "name": "UpdatePaymentTermsDialogMutation",
    "operationKind": "mutation",
    "text": "mutation UpdatePaymentTermsDialogMutation(\n  $input: UpdatePaymentTermsInput!\n) {\n  updatePaymentTerms(input: $input) {\n    id\n    paymentTerms\n  }\n}\n"
  }
};
})();

(node as any).hash = "1bff26b890c0a62af28692e19bf9ab22";

export default node;
